import Icon from "@/components/elements/icons/Icons";
import { IconLibrary } from "@/interfaces/IconLibrary";
import "../../../../css/global/pageSelectors/simplePageSelector.scss";



interface ISimplePageSelector {
  currentPage: number;
  totalPages: number;
  setPage: (page: number) => void;
}

const SimplePageSelector = ({currentPage, totalPages, setPage} : ISimplePageSelector) => {   

return (
  <div className={`simple-page-selector`}>
      <button type='button' className={`${currentPage === 1 && "muted"} start`} onClick={() => setPage(1)} disabled={currentPage === 1} aria-label="Go to first page"><Icon iconName={IconLibrary.SKIP_TO_FIRST} className="skip-to-start" color="#5F646A" sizeInPx="12"/></button>

      <button type='button' className={`${currentPage === 1 && "muted"} prev`} onClick={() => setPage(currentPage -1)} disabled={currentPage === 1} aria-label="Go to previous page"><Icon iconName={IconLibrary.SKIP_TO_PREVIOUS} className="skip-to-previous" color="#5F646A" sizeInPx="12"/></button>
  
      <div className="page-details"  aria-live="polite">Page {currentPage} of {totalPages}</div>

      <button type='button' className={`${currentPage === totalPages && "muted"} next`} onClick={() => setPage(currentPage +1)} disabled={currentPage === totalPages} aria-label="Go to next page"><Icon iconName={IconLibrary.SKIP_TO_NEXT} className="skip-to-next" color="#5F646A" sizeInPx="12"/></button>
    
      <button type='button' className={`${currentPage === totalPages && "muted"} end`}  onClick={() => setPage(totalPages)} disabled={currentPage === totalPages}  aria-label="Go to last page"><Icon iconName={IconLibrary.SKIP_TO_LAST} className="skip-to-last" color="#5F646A" sizeInPx="12"/></button>
  </div>
);
}

export default SimplePageSelector